// extracted by mini-css-extract-plugin
export default {"root":"MultiInput_root__AJxVZ","tag":"MultiInput_tag__FRGz2"};